import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import partial from 'lodash/partial';
import moment from 'moment';
import capitalize from 'lodash/capitalize';
import classnames from 'classnames';
import UploadModal from 'project/containers/wrapup/upload_bundles_modal';
import ApproveModal from 'project/containers/wrapup/approve_modal';
import DeleteBundleModal from 'project/containers/wrapup/delete_bundle_modal';
import { isCollaborator } from 'project/ducks/wrapup';
import { canCollaborate } from 'project/utils';

export default class Bundles extends Component {
  constructor(props) {
    super(props);

    this.state = { showingOlder: false };

    this.toggleOlder = this.toggleOlder.bind(this);
    this.toggleDeleteBundle = this.toggleDeleteBundle.bind(this);
  }

  toggleDeleteBundle(bundleId) {
    this.setState({ deletingBundleId: bundleId });
  }

  toggleOlder(idx) {
    this.setState({ showingOlder: !this.state.showingOlder });
  }

  renderAction({ isClient, isCollab, isAdmin }) {
    const {
      name, toggleUploadModal, bundles, approvedAt, project, toggleApproveModal,
      collaboratorApprovePerm
    } = this.props;

    /* bundles approved */
    if (approvedAt) {
      return (
        <div className="approved text-center">
          <h4 className="text-success"><i className="fa fa-check-circle"/> Approved</h4>
          <label>{ moment(approvedAt).format('MMMM D, YYYY hh:mm a') }</label>
        </div>
      );
    };

    if (isClient || isCollab || isAdmin) {
      /* no bundles uploaded yet */
      if (bundles.length === 0) {
        return null;
      }

      if (isCollab && !canCollaborate(project, collaboratorApprovePerm)) {
        return (
          <div className="callout warning">
            { capitalize(name) } were uploaded, but you don't have permissions
            to approve them.
          </div>
        );
      }

      return (
        <button className="btn btn-success" onClick={toggleApproveModal}>
          Approve { name } and move to next step
        </button>
      );
    }

    return (
      <button className="btn btn-tertiary" onClick={toggleUploadModal}>
        Add { bundles.length > 0? "new or revised" : "" } { name }
      </button>
    );
  }

  renderBundles({ isCreative, isAdmin }) {
    const { bundles, name, approvedAt, wrapup, actionless } = this.props;
    const { showingOlder } = this.state;

    /* no files uploaded yet */
    if (bundles.length === 0) {
      if (isCreative) {
        return <h5 className="text-danger">You have not added { name }.</h5>;
      }
      return <h5 className="text-danger">
        Waiting for { wrapup.creative.username } to upload { name }.
      </h5>;
    }

    if (isCreative && !actionless) {
      return (
        <div>
          <div className="bundles-msg">
            { !!approvedAt?
            <h5 className="text-success">
              Congratulations! The client approved your { name }.
            </h5> :
            <h5 className="text-danger">
              You have added { name } but the client has not yet approved them.
            </h5> }
          </div>

          <h4>Most recent { name }</h4>
          { this.renderBundle(bundles[0], isAdmin) }

          { bundles.length > 1 &&
          <div className="older">
            <h4 onClick={this.toggleOlder}>
              Older { name } <i className={"fa fa-" + (showingOlder? "minus" : "plus")} />
            </h4>
            { showingOlder && bundles.slice(1).map((b) => this.renderBundle(b, isAdmin)) }
          </div> }
        </div>
      );
    }

    return (
      <div>
        <div className="row">
          <div className="columns small-2">
            <Link to={bundles[0].zip} target="_blank">
              <i className="fa fa-download" />
            </Link>
          </div>
          <div className="columns small-14">
            <h4>Download most recent { name }</h4>
            { this.renderBundle(bundles[0], isAdmin) }
          </div>
        </div>

        { bundles.length > 1 &&
        <div className="row">
          <div className="columns small-16 large-14 large-offset-2">
            <div className="older">
              <h4 onClick={this.toggleOlder}>
                Download older { name } <i className={"fa fa-" + (showingOlder? "minus" : "plus")} />
              </h4>
              { showingOlder && bundles.slice(1).map((b) => this.renderBundle(b, isAdmin)) }
            </div>
          </div>
        </div> }
      </div>
    );
  }

  renderBundle(bundle, isAdmin) {
    const { actionless } = this.props;

    return (
      <div className="bundle" key={bundle.id}>
        <Link href={bundle.zip} target='_blank'>
          { decodeURIComponent(bundle.zip.split('/').slice(-1)) } <span className="upload-date">
          (uploaded { moment(bundle.last_updated).format('MMMM D, YYYY hh:mm a') })</span>
        </Link>
        { isAdmin && !actionless &&
        <i className="fa fa-trash text-danger" onClick={partial(this.toggleDeleteBundle, bundle.id)} /> }
      </div>
    );
  }

  render() {
    const {
      name, wrapup, showingUploadModal, showingApproveModal, bundles, approveDescr,
      approveChecklist, approveConfirmation, onApprove, acceptedFormats, user,
      itemsToUpload, project, approveDisclaimer, actionless
    } = this.props;

    const isCreative = user.id == wrapup.creative.id;
    const isClient = user.id == wrapup.client.id;
    const isAdmin = user.is_staff;
    const isCollab = isCollaborator(wrapup, user);

    const action = this.renderAction({ isClient, isCollab, isAdmin });

    return (
      <div>
        <div className="bundles">
          { this.renderBundles({ isCreative, isAdmin }) }

          { !actionless && !!action && <div className="btn-container">{ action }</div> }
        </div>

        { showingUploadModal &&
        <UploadModal wrapup={wrapup} type={name} acceptedFormats={acceptedFormats}
          itemsToUpload={itemsToUpload} project={project} /> }

        { showingApproveModal &&
        <ApproveModal
          wrapup={wrapup}
          checklist={approveChecklist}
          disclaimer={approveDisclaimer}
          name={name}
          description={approveDescr}
          confirmation={approveConfirmation}
          onDone={onApprove} /> }

        <DeleteBundleModal
          toggleDialog={partial(this.toggleDeleteBundle, undefined)}
          bundleId={this.state.deletingBundleId}
          wrapup={wrapup}
          backendStepIdx={wrapup.backendSteps.indexOf(
            name === "proofs"? "approve_proofs" : "approve_files"
          )}
        />
      </div>
    );
  }
}

Bundles.propTypes = {
  name: PropTypes.string.isRequired,
  toggleUploadModal: PropTypes.func.isRequired,
  showingUploadModal: PropTypes.bool,
  showingApproveModal: PropTypes.bool,
  user: PropTypes.object.isRequired,
  wrapup: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  bundles: PropTypes.array.isRequired,
  approvedAt: PropTypes.string,
  toggleApproveModal: PropTypes.func.isRequired,
  onApprove: PropTypes.func,
  approveDescr: PropTypes.node,
  approveChecklist: PropTypes.string,
  approveConfirmation: PropTypes.string,
  approveDisclaimer: PropTypes.string,
  collaboratorApprovePerm: PropTypes.string,
  acceptedFormats: PropTypes.string,
  itemsToUpload: PropTypes.string,
  actionless: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./project/components/wrapup/bundles.jsx